// extracted by mini-css-extract-plugin
export var item = "c5_pv";
export var text = "c5_fm";